import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
    const { resolvedTheme, setTheme } = useTheme();
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    if (!mounted) return <div className="h-8 w-16" />;

    const isDark = resolvedTheme === "dark";

    return (
        <button
            type="button"
            role="switch"
            aria-checked={isDark}
            aria-label="Toggle theme"
            onClick={() => setTheme(isDark ? "light" : "dark")}
            data-testid="theme-toggle"
            className="group relative flex h-8 w-[58px] items-center rounded-full border-sb border px-1 transition-colors focus-ring"
            style={{ backgroundColor: "rgb(var(--sb-bg) / 0.5)" }}
        >
            <span
                className="absolute h-6 w-6 rounded-full bg-sb-mint transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]"
                style={{ transform: isDark ? "translateX(0)" : "translateX(26px)" }}
            />
            <span className="relative z-10 flex w-full justify-between px-1">
                <Moon className={`h-3 w-3 transition-colors ${isDark ? "text-[#0F2A4A]" : "text-sb-muted"}`} />
                <Sun className={`h-3 w-3 transition-colors ${!isDark ? "text-[#0F2A4A]" : "text-sb-muted"}`} />
            </span>
        </button>
    );
}
